export var BADGE_TYPE;
(function (BADGE_TYPE) {
    BADGE_TYPE["AD"] = "ad";
    BADGE_TYPE["FEATURED"] = "featured";
})(BADGE_TYPE || (BADGE_TYPE = {}));
